
    import { defineComponent } from 'vue'
    import { INode } from '../../../Workspace'
    import Dialog from 'primevue/dialog'
    import workspaceAnalysisViewShareDialogDescriptor from './WorkspaceAnalysisViewShareDialogDescriptor.json'
    import WorkspaceAnalysisFolderTree from '../tree/WorkspaceAnalysisFolderTree.vue'

    export default defineComponent({
        name: 'workspace-analysis-view-share-dialog',
        components: { Dialog, WorkspaceAnalysisFolderTree },
        props: { visible: { type: Boolean }, propFolders: { type: Array } },
        emits: ['close', 'share'],
        data() {
            return {
                workspaceAnalysisViewShareDialogDescriptor,
                folders: [] as any[],
                selectedFoldersKeys: {} as any
            }
        },
        computed: {
            buttonDisabled(): boolean {
                return (!this.selectedFoldersKeys || !this.selectedFoldersKeys.length || this.selectedFoldersKeys.length < 0)
            }
        },
        watch: {
            propFolders() {
                this.loadFolders()
            }
        },
        created() {
            this.loadFolders()
        },
        methods: {
            loadFolders() {
                this.folders = this.propFolders as any[]
            },
            closeDialog() {
                this.folders = []
                this.selectedFoldersKeys = {}   
                this.$emit('close')
            },
            shareDocument() {
                this.$emit('share', this.selectedFoldersKeys)
                this.selectedFoldersKeys = {}
            },
            setSelectedFolders(folders: INode[]) {
                this.selectedFoldersKeys = folders
            }
        }
    })
